import { PythonTopic } from '../../../../types/python-topic';
import { clasesObjetosExercises } from './exercises';

export const clasesObjetosTopic: PythonTopic = {
  id: 9,
  title: 'Clases y objetos',
  description: 'Aprende programación orientada a objetos en Python: clases, herencia, métodos especiales y estructuras de datos.',
  theory: `# Clases y Objetos en Python

## ¿Qué aprenderás en esta sección?

Esta sección te introduce a:
1. **Introducción a POO**: Conceptos de programación orientada a objetos
2. **Clases**: Crear y usar clases
3. **Herencia**: Reutilizar código con herencia
4. **Métodos especiales**: Métodos mágicos de Python
5. **Pilas y colas**: Implementar estructuras de datos

## Programación Orientada a Objetos

Aprenderás:
- Conceptos fundamentales de POO
- Cómo crear y usar clases
- Encapsulación, herencia y polimorfismo
- Diseño orientado a objetos

## Estructuras de Datos

Implementarás:
- Pilas (stacks)
- Colas (queues)
- Otras estructuras de datos comunes

## Estructura de esta sección

Cada ejercicio incluye teoría expandida, ejemplos prácticos y ejercicios para que puedas practicar a tu propio ritmo.`,
  difficulty: 'advanced',
  exercises: clasesObjetosExercises
};

